import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { Box } from "@chakra-ui/react";
import { OperacaoEnum } from "core/resources/enums/conta";
import { TipoDataConta } from "core/features/conta/typings";

const { Option } = Select;

export interface SelectTipoDataProps<T = any> extends SelectProps<T> {
  bg?: string;
  value: any;
  onChange: (v: any) => void;
  operacao?: OperacaoEnum;
  filterOptions?: TipoDataConta[];
  allowClear?: boolean;
}

function SelectTipoData({
  value,
  operacao,
  filterOptions = [],
  allowClear = false,
  ...rest
}: SelectTipoDataProps) {
  return (
    <Box bg={rest.bg} rounded="6px" w="100%" minW={180}>
      <SelectBaseAntd
        size="large"
        getPopupContainer={(node) => node.parentNode}
        placeholder="Selecione"
        allowClear={allowClear}
        value={value}
        {...rest}
      >
        {!filterOptions.includes("vencimento") ? (
          <Option value={"vencimento"}>Data de Vencimento</Option>
        ) : null}
        {!filterOptions.includes("competencia") ? (
          <Option value={"competencia"}>Data de Competência</Option>
        ) : null}
        {!filterOptions.includes("liquidacao") ? (
          <Option value={"liquidacao"}>Data de Liquidação</Option>
        ) : null}
        {!filterOptions.includes("movimentacao") &&
        operacao === OperacaoEnum.Receita ? (
          <Option value={"movimentacao"}>Data da Movimentação Bancária</Option>
        ) : null}
        {!filterOptions.includes("geracao") ? (
          <Option value={"geracao"}>Data de Geração</Option>
        ) : null}
      </SelectBaseAntd>
    </Box>
  );
}

export default SelectTipoData;
